import { Search, UserPlus } from "lucide-react";
import { useEffect, useState } from "react";
import { Button, Input, Select } from "@/components/common";
import type { Role, UserStatus } from "@/types/rbac";

interface UsersToolbarProps {
  search: string;
  onSearchChange: (search: string) => void;
  status: UserStatus | "all";
  onStatusChange: (status: UserStatus | "all") => void;
  roleId: string | "all";
  onRoleChange: (roleId: string | "all") => void;
  roles: Role[];
  onInvite: () => void;
  canInvite?: boolean;
}

const statusOptions = [
  { value: "all", label: "Wszystkie statusy" },
  { value: "active", label: "Aktywni" },
  { value: "invited", label: "Zaproszeni" },
  { value: "disabled", label: "Wyłączeni" },
];

export function UsersToolbar({
  search,
  onSearchChange,
  status,
  onStatusChange,
  roleId,
  onRoleChange,
  roles,
  onInvite,
  canInvite = true,
}: UsersToolbarProps) {
  const [localSearch, setLocalSearch] = useState(search);

  // Debounce search
  useEffect(() => {
    const timer = setTimeout(() => {
      onSearchChange(localSearch);
    }, 300);
    return () => {
      clearTimeout(timer);
    };
  }, [localSearch, onSearchChange]);

  // Sync external search prop
  useEffect(() => {
    setLocalSearch(search);
  }, [search]);

  const roleOptions = [
    { value: "all", label: "Wszystkie role" },
    ...roles.map((r) => ({ value: r.id, label: r.name })),
  ];

  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
      <div className="flex-1">
        <Input
          value={localSearch}
          onChange={(e) => {
            setLocalSearch(e.target.value);
          }}
          placeholder="Szukaj agentów..."
          leftIcon={<Search size={16} />}
        />
      </div>

      <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
        <Select
          options={statusOptions}
          value={status}
          onChange={(val) => {
            onStatusChange(val as UserStatus | "all");
          }}
          className="w-full sm:w-44"
        />

        <Select
          options={roleOptions}
          value={roleId}
          onChange={(val) => {
            onRoleChange(val);
          }}
          className="w-full sm:w-44"
        />

        {canInvite && (
          <Button
            leftIcon={<UserPlus size={16} />}
            onClick={onInvite}
            className="w-full sm:w-auto"
          >
            Zaproś
          </Button>
        )}
      </div>
    </div>
  );
}
